import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.blockquote`
  display: flex;
  margin: 4rem auto;
  max-width: 80rem;
  padding: 0 2rem;
  & p:last-child {
    text-align: right;
  }
  & p:first-child {
    text-align: left;
  }
`

const Quote = styled.div`
  position: relative;
  font-size: 14rem;
  opacity: 1;
  color: ${({ theme }) => theme.colors.interactive};

  &:before {
    font-family: Arial;
    content: '“';
    color: ${({ theme }) => theme.colors.interactive};
    font-size: 14rem;
    position: absolute;
    left: 10px;
    top: -7rem;
  }
`

const Content = styled.div`
  flex: 1;
  padding: 0 0 1rem 7rem;
  font-style: italic;
  font-size: 1.8rem;
  text-align: left;
  margin: 0;
  & p {
    margin-bottom: 0;
  }
`

const Blockquote = (props) => (
  <Container>
    <Quote />
    <Content>{props.children}</Content>
  </Container>
)

Blockquote.propTypes = {
  children: PropTypes.node.isRequired
}

export default Blockquote
